module.exports = __webpack_public_path__ + "static/media/recording.db95c5f2.svg";